import { SlackChannel } from "@reflag/shared/slackConnectionAPI";

export function normalizeSlackChannel(
  slackChannel: SlackChannel | "inherit" | null | undefined,
) {
  if (slackChannel === undefined) {
    return undefined;
  }

  if (slackChannel === null) {
    return null;
  }

  return slackChannel === "inherit" ? null : slackChannel;
}
